import AppRoutes from "./routing/router";

function App() {
  return (
    <div>
      <AppRoutes />
    </div>
  );
}

export default App;
